<template>
    <md-dialog :md-active="!!url" @md-clicked-outside="onClose">
        <div style="height: 315px; width: 560px">
            <iframe v-if="!!url" width="560" height="315" :src="url" frameborder="0" allow="encrypted-media" allowfullscreen />
        </div>
    </md-dialog>
</template>

<script>
export default {
    props: {
        url: String,
    },
    methods: {
        onClose() {
            this.$root.viewVideoUrl = '';
        },
    },
};
</script>

<style lang="scss" scoped>
iframe {
    width: 100%;
    height: 315px !important;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/VideoModal.vue